<template>
	<Modal v-model="show" title="新增苗场对客户经理的认可关系" :width="60">
		<Spin v-if="$globalSpin" size="large" fix></Spin>
		<Form ref="modelForm" :model="modelForm" :rules="ruleValidate" label-position="top" class="small-form">

			<Row :gutter="16">
				<Col span="24">
				<FormItem label="选择客户经理" prop="userCustomerManagerUuid">
					<Select v-model="modelForm.userCustomerManagerUuid" filterable>
						<Option v-for="item in userCustomerManagerList" :key="item.userCustomerManagerLoginUuid"
							:value="item.userCustomerManagerLoginUuid">{{ item.userCustomerManagerName }}
						</Option>
					</Select>
				</FormItem>
				</Col>
				<Col span="6">
				<FormItem label="是否认可" prop="recordStatus">
					<RadioGroup v-model="modelForm.recordStatus" type="button">
						<Radio v-for="item in statusSource" :key="item.val" :label="item.val">{{ item.label }}
						</Radio>
					</RadioGroup>
				</FormItem>
				</Col>
			</Row>
		</Form>
		<div slot="footer">
			<Button type="primary" @click="onSave">确认</Button>
			<Button type="error" @click="onCancel">取消</Button>
		</div>
	</Modal>
</template>

<script>
import {
    STATUS_ACCEPT_YES,
    STATUS_ACCEPT_NO,
    statusAcceptFormat
} from '@/libs/baseModelFormat';
import {
    FORM_EDIT_MODE_CREATE,
    FORM_EDIT_MODE_MODIFY
} from '@/view/mixins/form-edit-mode';

import {
    addSeedFarmAcceptCusMgr,
    getUserCustomerManagerList,
    updateSeedFarmAcceptCusMgr
} from '@/api/modules/account-management/customerManager-user-management';

export default {
    name: 'RelationshipRecognitionEdit',
    data() {
        return {
            show: false,
            uuid: '',
            FORM_EDIT_MODE_CREATE,
            FORM_EDIT_MODE_MODIFY,
            formEditMode: FORM_EDIT_MODE_CREATE,
            pageLoading: false,
            modelForm: {
                userCustomerManagerUuid: '',
                recordStatus: STATUS_ACCEPT_YES
            },
            ruleValidate: {
                userCustomerManagerUuid: [{
                    trigger: 'blur',
                    required: true,
                    validator: (rule, value, callback) => {
                        if (value) {
                            callback();
                        }
                        else {
                            callback(new Error(' '));
                        }
                    }
                }]
            },
            statusSource: [],
            userCustomerManagerList: []
        };
    },
    mounted() {},
    methods: {
        showModal(uuid) {
            if (uuid == '') {
                this.uuid = '';
                this.formEditMode = FORM_EDIT_MODE_CREATE;
            }
            else {
                this.formEditMode = FORM_EDIT_MODE_MODIFY;
                this.uuid = uuid;
            }
            this.init();
            this.show = true;
        },
        init() {
            this.statusSource = [];
            this.statusSource.push({
                val: STATUS_ACCEPT_YES,
                label: statusAcceptFormat(STATUS_ACCEPT_YES)
            });
            this.statusSource.push({
                val: STATUS_ACCEPT_NO,
                label: statusAcceptFormat(STATUS_ACCEPT_NO)
            });
            this.getUserCustomerManagerList();
            this.$refs.modelForm.resetFields();
        },
        getUserCustomerManagerList() {
            getUserCustomerManagerList({}).then(res => {
                if (res.code === 0) {
                    this.userCustomerManagerList = res.data.records;
                }
            });
        },
        onSave() {
            this.$refs.modelForm.validate(valid => {
                if (!valid) {
                    this.$Message.error('表单验证失败!');
                    return;
                }
                const data = Object.assign({
                    formEditMode: this.formEditMode
                }, this.modelForm);

                this.$showGlobalSpin();
                addSeedFarmAcceptCusMgr(data).then(res => {
                    this.$hideGlobalSpin();
                    if (res.code === 0) {
                        this.$Modal.success({
                            title: '保存成功',
                            onOk: () => {
                                this.show = false;
                                this.$refs.modelForm.resetFields();
                                this.$parent.getTableRecords();
                            }
                        });
                    }
                });
            });
        },
        onCancel() {
            this.show = false;
            this.$refs.modelForm.resetFields();
        }
    }
};
</script>

<style scoped>
</style>
